import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isObject from '../../general/isObject';

import * as exElement from '../element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    const defConfig: Record<string, any> = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (container)
    const elContainer = exElement.create({
        merge: defConfig,
        class: {
            new: 'container',
        },
    });
    elements.element = elContainer;

    // ------------------------------------------------------------------------

    // If using data
    if (!isEmptyArray(config.data)) {
        const list = data(config);
        elContainer.appendChildren(list.elements);
        elements.list = list;
    }

    // ------------------------------------------------------------------------

    //
    return elements;
}

function data(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        rows: {},
        columns: {},
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list: Record<string, any> = {
        elements: [],
        rows: [],
    };

    // Foreach Data
    for (let i = 0; i < config.data.length; i++) {
        let itemRow = config.data[i];

        //
        list.rows[i] = {
            columns: [],
        };

        //
        const defConfigRow: Record<string, any> = {
            ...defConfig.rows,
            ...itemRow,
        };

        // Create element (row)
        const elRow = exElement.create({
            merge: defConfigRow,
            class: {
                new: 'row',
            },
        });
        list.rows[i].element = elRow;

        //
        if (isObject(itemRow)) {
            itemRow = itemRow.columns;
        }

        // Foreach Row
        for (let ii = 0; ii < itemRow.length; ii++) {
            const itemColumn = itemRow[ii];

            //
            list.rows[i].columns[ii] = {};

            //
            const defConfigColumn: Record<string, any> = {
                ...defConfig.columns,
                ...itemColumn,
            };

            // Create element (column)
            const elColumn = exElement.create({
                merge: defConfigColumn,
                class: {
                    new: 'col',
                },
            });
            elRow.appendChild(elColumn);
            list.rows[i].columns[ii].element = elColumn;
        }

        // --------------------------------------------------------------------

        //
        list.elements.push(elRow);
    }

    // ------------------------------------------------------------------------

    //
    return list;
}

// ----------------------------------------------------------------------------

export { create, data };
